<template>
    <div>
        <form v-on:submit.prevent="search(searchData.searchManufacturerId,searchData.searchText)">
            <select class="form-control mt-2 mb-2" v-model="searchData.searchManufacturerId">
                <option value="" selected>All Manufacturers</option>
                <option v-for="manufacturer in searchData.manufacturerList" v-bind:value="manufacturer.id" v-bind:key="manufacturer.id">{{manufacturer.name}}</option>
            </select>
            <input class="form-control mt-2 mb-2" v-model="searchData.searchText" placeholder="Part Number" />
            <button class="btn btn-dark mt-2 mb-2" type="submit" v-bind:disabled="searchData.searchManufacturerId == '' && searchData.searchText == ''">Search</button>
        </form>
        <div class="mt-2">
            <SearchLine v-for="line in searchData.searchResult.items" v-bind:key="line.partUniqueId" v-bind:searchItem="line"></SearchLine>
        </div>
        <div>
            <SearchPager v-bind:pagerContent="searchData.searchResult.paging"></SearchPager>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import SearchLine from "./SearchLine.vue";
    import SearchPager from "./SearchPager.vue";

    export default {
        name: 'SearchPanel',
        components: {
            SearchLine,
            SearchPager
        },
        props: {
            searchData: {
                type: Object,
                default: () => {
                    return {
                        manufacturerList: [],
                        searchResult: {
                            items: [],
                            queryText: "",
                            mfrId: "",
                            paging: {
                                showPaging: true,
                                url: "",
                                pages: []
                            },
                            resultCount: 0
                        },
                        searchManufacturerId: "",
                        searchText: ""
                    }
                }
            }
        },
        computed: {
            appUrl: function () {
                return process.env.VUE_APP_API_URL;
            }
        },
        methods: {
            setup: function () {
                //Define manufacturers on startup
                //Axios call out to parameterless url
                axios
                    .get(this.appUrl + '/api/v1/part/manufacturerlisting', { crossdomain: true })
                    .then(response => (this.searchData.manufacturerList = response.data));
            },
            search(mfrId, queryText) {
                this.$root.$emit('search_parts', mfrId, queryText);
            }
        },
        beforeMount() {
            this.setup()
        }
    };
</script>

<style>
    .search-result-item {
        border: 1px solid #dbdbdb;
    }

    .ul-wide-border-panel {
        border-left: 10px solid #c51730 !important;
    }

    .search-result-item-mfr-heading {
        flex: 0 0 30%;
    }

    .search-result-item-border {
        border-left: 1px solid #dbdbdb;
    }


</style>